import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Main from "../Main";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import { useDispatch, useSelector } from "react-redux";
import { getSellerOrdersById } from "../../../Redux/OrderRedux";
import { updateOrderStatus } from "../../../Redux/OrderRedux";
import { requestProductReturn } from "../../../Redux/OrderRedux";

import {
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
function OrderDetails() {
  const dispatch = useDispatch();
  const { user_id, seller_id } = useParams();
  const role =
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).role;
  const { sellerOrdersById } = useSelector((state) => state.orderRedux);

  // popup state for shipping
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [shipperName, setShipperName] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [trackingUrl, setTrackingUrl] = useState("");
  const [currentStatus, setCurrentStatus] = useState();
  const BASE_URL = process.env.REACT_APP_API_URL;

  // Return Reason Dialog State
  const [returnDialogOpen, setReturnDialogOpen] = useState(false);
  const [returnItem, setReturnItem] = useState(null);
  const [returnReason, setReturnReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const returnReasons = [
    "Expired or Near-Expiry Product",
    "Damaged or Leaking Packaging",
    "Wrong Item Delivered",
    "Poor Quality or Spoiled Food",
    "Quantity / Weight Issue",
    "Other",
  ];

  const totalPrice = sellerOrdersById.orders?.products?.reduce((acc, item) => {
    return acc + item.quantity * item.price;
  }, 0);

  useEffect(() => {
    if (user_id) {
      dispatch(getSellerOrdersById(user_id, seller_id));
    }
  }, [dispatch, user_id, seller_id, update]);

  // update order status with optional shipping data
  const handleUpdateStatus = async (
    orderId,
    seller_id,
    status,
    extraData = {}
  ) => {
    await dispatch(
      updateOrderStatus(orderId, seller_id, { status, ...extraData })
    );
    dispatch(getSellerOrdersById(user_id, seller_id));
  };

  // handle shipping form submit
  const handleShippingSubmit = () => {
    handleUpdateStatus(sellerOrdersById.orders._id, seller_id, "Shipped", {
      shipperName,
      trackingId,
      trackingUrl,
    });
    setOpen(false);
    setShipperName("");
    setTrackingId("");
    setTrackingUrl("");
  };

  const steps = ["NewOrder", "Packed", "Shipped", "Delivered"];
  const sellerProducts =
    sellerOrdersById?.orders?.products?.filter(
      (p) => p.sellerId === seller_id
    ) || [];

  const productStatus = sellerProducts.reduce((latest, p) => {
    const currentIndex = steps.indexOf(p.status);
    const latestIndex = steps.indexOf(latest);
    return currentIndex > latestIndex ? p.status : latest;
  }, "NewOrder");
  const activeStep = steps.indexOf(productStatus);

  const formatDateTime = (isoString) => {
    if (!isoString) {
      return "";
    }
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    const formattedDate = `${day}-${month}-${year}`;

    const options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", options);

    return `${formattedDate} ${formattedTime}`;
  };

  const isWithinReturnWindow = (deliveredAt) => {
    if (!deliveredAt) return false;
    const deliveredDate = new Date(deliveredAt);
    const now = new Date();
    const diffMs = now - deliveredDate;
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    return diffDays >= 0 && diffDays <= 7;
  };

  const handleReturn = (item) => {
    setReturnItem(item);
    setReturnDialogOpen(true);
    setReturnReason("");
    setOtherReason("");
  };

  const handleReturnConfirm = async () => {
    // Determine final reason
    const finalReason =
      returnReason === "Other" ? otherReason.trim() : returnReason;

    if (!finalReason) {
      toast.error("Please select or enter a reason before submitting.");
      return;
    }

    // Dispatch Redux action with correct reason
    dispatch(
      requestProductReturn(
        returnItem._id, // or returnItem.productId if that’s what backend expects
        "RETURNING",
        "Cancelled",
        finalReason,
        user_id,
        seller_id
      )
    );

    setReturnDialogOpen(false);
  };

  const handleApproveReturned = async (orderId, sellerId, productId) => {
    try {
      // Update the order status and returnStatus
      await handleUpdateStatus(orderId, sellerId, "Cancelled", {
        returnStatus: "RETURNED",
        productId,
      });

      // toast.success("Product marked as Returned successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update return status");
    }
  };

  return (
    <>
      <Main>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          {sellerOrdersById.orders ? (
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <h4>Order Details</h4>
                </div>
              </div>
              {/* Stepper */}
              {/* <div className="row my-3">
                <div className="col-12">
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label, index) => (
                      <Step key={label} completed={index <= activeStep}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </div>
              </div> */}
              <div className="mt-2">
                <Card
                  variant="outlined"
                  sx={{
                    backgroundColor: "#e9eef0",
                  }}
                >
                  <CardContent>
                    <div className="row">
                      <div className="col-md-6">
                        <h6>
                          Order Id:{" "}
                          <span>{sellerOrdersById.orders.orderId}</span>
                        </h6>
                      </div>
                      <div className="col-md-6">
                        <h6>
                          Order Date:{" "}
                          <span>
                            {new Date(
                              sellerOrdersById.orders.createdAt
                            ).toLocaleDateString("en-GB")}
                          </span>
                        </h6>
                      </div>

                      <div className="col-md-6 mt-2">
                        <h6>
                          User Name:{" "}
                          <span>{sellerOrdersById.orders.userName}</span>
                        </h6>
                      </div>
                      {/* <div className='col-md-6 mt-2'>
                        <h6>
                          User Id:{' '}
                          <span>{sellerOrdersById.orders.user_id}</span>
                        </h6>
                      </div> */}

                      {role === "buyer" && (
                        <>
                          <div className="col-md-6 mt-2">
                            <h6>
                              Product Total:{" "}
                              <span>{sellerOrdersById.orders.subtotal} /-</span>
                            </h6>
                          </div>
                          <div className="col-md-6 mt-2">
                            <h6>
                              Shipping Cost:{" "}
                              <span>
                                {sellerOrdersById.orders.shippingcost}
                              </span>
                            </h6>
                          </div>
                        </>
                      )}

                      {/* <div className="col-md-6 mt-2">
                        <h6>
                          Status: <span>{sellerOrdersById.orders.status}</span>
                        </h6>
                      </div> */}
                      <div className="col-md-6 mt-2">
                        <h6>
                          Phone Number:{" "}
                          <span>{sellerOrdersById.orders.phoneNo}</span>
                        </h6>
                      </div>

                      <div className="col-md-6 mt-2">
                        <h6>
                          Order Total:
                          <span>
                            {role !== "buyer"
                              ? `${totalPrice} /-`
                              : `${sellerOrdersById.orders.total} /-`}
                          </span>
                        </h6>
                      </div>
                      <div className="col-md-6 mt-2">
                        <h6>Delivered Address:</h6>
                        <p className="fw-medium">
                          {
                            sellerOrdersById?.orders?.deliveryaddress
                              ?.doorNumber
                          }
                          ,{" "}
                          {sellerOrdersById?.orders?.deliveryaddress?.homeName},{" "}
                          {sellerOrdersById?.orders?.deliveryaddress?.street},{" "}
                          {
                            sellerOrdersById?.orders?.deliveryaddress
                              ?.townOrCity
                          }
                          , {sellerOrdersById?.orders?.deliveryaddress?.state},{" "}
                          {sellerOrdersById?.orders?.deliveryaddress?.country} -{" "}
                          {sellerOrdersById?.orders?.deliveryaddress?.pincode}
                        </p>
                      </div>
                      {(role === "seller" || role === "admin") && (
                        <div className="col-md-6 mt-2">
                          <h6>
                            Transaction Id:{" "}
                            <span>{sellerOrdersById.orders.transactionId}</span>
                          </h6>
                        </div>
                      )}
                    </div>

                    {/* Update buttons for sellers */}

                    {role === "seller" && (
                      <div className="col-md-12 mt-3 d-flex gap-2">
                        {sellerOrdersById.orders?.products?.some(
                          (p) => p.returnStatus === "RETURNED"
                        ) ? (
                          // ✅ Case 1: Already Returned & Approved
                          <Button
                            variant="contained"
                            disabled
                            sx={{
                              backgroundColor: "#4caf50",
                              color: "#ffffff",
                              textTransform: "capitalize",
                              fontWeight: "bold",
                              "&.Mui-disabled": {
                                backgroundColor: "#4caf50",
                                color: "#ffffff",
                                opacity: 1,
                              },
                            }}
                          >
                            Status : Return Approved
                          </Button>
                        ) : sellerOrdersById.orders?.products?.some(
                            (p) => p.returnStatus === "RETURNING"
                          ) ? (
                          // ✅ Case 2: Returning Products Exist
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={() => {
                              const returningProducts =
                                sellerOrdersById.orders?.products?.filter(
                                  (p) => p.returnStatus === "RETURNING"
                                );

                              returningProducts?.forEach((product) => {
                                handleApproveReturned(
                                  sellerOrdersById.orders._id,
                                  seller_id,
                                  product._id // ✅ or product.productId depending on your structure
                                );
                              });
                            }}
                          >
                            Approve Returned
                          </Button>
                        ) : (
                          // ✅ Case 3: Normal Flow (Step Buttons)
                          steps.map((status, index) => {
                            if (index === activeStep + 1) {
                              if (status === "Shipped") {
                                return (
                                  <Button
                                    key={status}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setOpen(true)}
                                  >
                                    Mark as {status}
                                  </Button>
                                );
                              }
                              return (
                                <Button
                                  key={status}
                                  variant="contained"
                                  color="primary"
                                  onClick={() =>
                                    handleUpdateStatus(
                                      sellerOrdersById.orders._id,
                                      seller_id,
                                      status
                                    )
                                  }
                                >
                                  Mark as {status}
                                </Button>
                              );
                            }
                            return null;
                          })
                        )}
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>
              <div className="row mt-3">
                <h5>Product Details</h5>
              </div>
              <div className="row mt-2">
                {sellerOrdersById.orders?.products?.length > 0 &&
                  sellerOrdersById.orders.products.map((item, itemIndex) => {
                    // Calculate steps and active step for the current item
                    const cardSteps = steps || [];
                    const activeCardStep = cardSteps.indexOf(item.status);

                    return (
                      <div className="col-4 mb-4" key={item.productId}>
                        <Card
                          sx={{
                            maxWidth: 345,
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "#e9eef0",
                          }}
                        >
                          <CardActionArea
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              flexGrow: 1,
                            }}
                          >
                            <CardMedia
                              component="img"
                              height="140"
                              image={`${BASE_URL}/assets/images/products/${item?.image}`}
                              alt={item?.productName || "Product image"}
                            />
                            <CardContent sx={{ flexGrow: 1, width: "100%" }}>
                              <h6 className="text-center">
                                {item.productName}
                              </h6>
                              {[
                                {
                                  label: "Seller",
                                  value: item.sellerName,
                                },
                                {
                                  label: "Ordered Quantity",
                                  value: item.quantity,
                                },
                                {
                                  label: "Quantity Size",
                                  value: item.quantity,
                                },
                                { label: "Category", value: item.category },
                                { label: "Price", value: `${item.price} /-` },
                                {
                                  label: "Total Price",
                                  value: `${item.quantity * item.price} /-`,
                                },
                              ].map(({ label, value }) => (
                                // <div className="row" key={label}>
                                //   <div className="col-5">
                                //     <p>{label}</p>
                                //   </div>
                                //   <div className="col-1">
                                //     <p>:</p>
                                //   </div>
                                //   <div className="col-auto">
                                //     <p>{value}</p>
                                //   </div>
                                // </div>
                                <div
                                  key={label}
                                  className="d-flex align-items-center"
                                >
                                  {/* FIRST COLUMN: label + colon */}
                                  <div className="col-6 d-flex justify-content-between align-items-center m-1">
                                    <span>{label}</span>
                                    <span>:</span>
                                  </div>

                                  {/* SECOND COLUMN: value */}
                                  <div className="col-6 m-1 d-flex align-items-center">
                                    <p className="m-0">{value}</p>
                                  </div>
                                </div>
                              ))}

                              <div className="row mt-3">
                                {item.status === "Cancelled" ||
                                item.status === "PaymentPending" ||
                                item.status === "PaymentFailed" ? (
                                  <p className="text-center text-danger fw-bold bg-light">
                                    Status :{" "}
                                    {item.status === "Cancelled"
                                      ? item.returnStatus || "Cancelled"
                                      : item.status}
                                  </p>
                                ) : (
                                  <>
                                    <Stepper
                                      activeStep={activeCardStep}
                                      alternativeLabel
                                      className="p-1"
                                    >
                                      {cardSteps.map((label, index) => (
                                        <Step
                                          key={label}
                                          completed={index <= activeCardStep}
                                          className="p-1"
                                        >
                                          <StepLabel>
                                            {label}

                                            {label === "NewOrder" &&
                                              item.newOrderAt && (
                                                <p>
                                                  {formatDateTime(
                                                    item.newOrderAt
                                                  )}
                                                </p>
                                              )}

                                            {label === "Packed" &&
                                              item.packedAt && (
                                                <p>
                                                  {formatDateTime(
                                                    item.packedAt
                                                  )}
                                                </p>
                                              )}

                                            {label === "Shipped" &&
                                              item.shippedAt && (
                                                <p>
                                                  {formatDateTime(
                                                    item.shippedAt
                                                  )}
                                                </p>
                                              )}

                                            {label === "Delivered" &&
                                              item.deliveredAt && (
                                                <p>
                                                  {formatDateTime(
                                                    item.deliveredAt
                                                  )}
                                                </p>
                                              )}
                                          </StepLabel>
                                        </Step>
                                      ))}
                                    </Stepper>
                                  </>
                                )}
                              </div>
                            </CardContent>
                            <div className="row mt-3">
                              <div className="col-12 text-center mb-2">
                                {item.status === "Delivered" &&
                                role != "seller" ? (
                                  isWithinReturnWindow(item.deliveredAt) ? (
                                    <Button
                                      variant="contained"
                                      color="success"
                                      onClick={() => handleReturn(item)}
                                    >
                                      Return
                                    </Button>
                                  ) : (
                                    // <Button variant="contained" disabled>
                                    //   Return window expired
                                    // </Button>
                                    <></>
                                  )
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </CardActionArea>
                        </Card>
                      </div>
                    );
                  })}
              </div>
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row">{sellerOrdersById.message}</div>
            </div>
          )}
        </Box>
      </Main>
      {/* Shipping popup */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Enter Shipping Details</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Shipper Name"
            value={shipperName}
            onChange={(e) => setShipperName(e.target.value)}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Tracking ID"
            value={trackingId}
            onChange={(e) => setTrackingId(e.target.value)}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Tracking URL"
            value={trackingUrl}
            onChange={(e) => setTrackingUrl(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!shipperName || !trackingId || !trackingUrl}
            onClick={handleShippingSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Return Reason Dialog */}
      <Dialog
        open={returnDialogOpen}
        onClose={() => setReturnDialogOpen(false)}
      >
        <DialogTitle>Request return for {returnItem?.productName}</DialogTitle>
        <DialogContent>
          {returnReasons.map((reason) => (
            <div key={reason} style={{ marginBottom: 8 }}>
              <label style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  name="returnReason"
                  value={reason}
                  checked={returnReason === reason}
                  onChange={() => setReturnReason(reason)}
                />
                <span style={{ marginLeft: 8 }}>{reason}</span>
              </label>
            </div>
          ))}
          {returnReason === "Other" && (
            <TextField
              fullWidth
              margin="dense"
              label="Enter reason"
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReturnDialogOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleReturnConfirm}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default OrderDetails;
